import React from 'react'

import { Avatar } from '../shared/avatar'
import type { TimelineProps } from './timeline'

export type TimelineAvatarProps = Pick<
  TimelineProps,
  'avatarType' | 'avatar' | 'handle'
>

export const TimelineAvatar = ({
  avatarType,
  avatar,
  handle,
}: TimelineAvatarProps) => (
  <>
    {(avatarType === 'popup' || avatarType === 'readonly') &&
      (avatar || <Avatar handle={handle || undefined} />)}
    {avatarType === 'spacer' && <div className="timeline__avatar-spacer" />}
  </>
)
